import axiosInstance from 'api/axiosInstance';
import type { TagItemType } from 'types/repository.types';

const updateRepositoryTag = ({
  tagId,
  tagName,
}: {
  tagId: string;
  tagName: string;
}): Promise<TagItemType> =>
  axiosInstance.put(`/v2/repository-document-tags/${tagId}`, {
    name: tagName,
  });

export default updateRepositoryTag;
